
import { Injectable } from '@angular/core';
import { Validacao } from './validacao';
import { Estudo } from '../estudo/estudo';
import { Observable } from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { HttpService } from 'ems-oauth2-client';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class ValidacaoService extends ServiceUtil  {
    private url = '/sae/validacao';
    private filtro : Validacao = new Validacao();

    constructor(private http: HttpService, private pagerComponent: PagerComponent) { super(); }

    // altera ou inclui Validacao
    public update(validacao: Validacao): Observable<Validacao> {
        validacao.listaRespostaItem = null;
        const body = JSON.stringify(validacao, this.removeNull);

        if (!validacao.id) {
          return this.http.post(this.url, body)
            .pipe(map(response => <Validacao> response),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
        } else {
          return this.http.put(this.url + '/' + validacao.id , body)
            .pipe(map(response => <Validacao> response),
                 catchError(this.handleError),
                 publishReplay(1),
                 refCount());
        }
    }

    // deleta Validacao
    public deletar(validacao: Validacao): Observable<Validacao> {
      validacao.listaRespostaItem = null;
      return this.http.delete(this.url + '/' + validacao.id)
        .pipe(map(response => response),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
    }

    // lista todos (sem filtro)
    public listar(): Observable<Validacao[]> {
      return this.http.get(this.url)
            .pipe(map(this.extractListData),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
    }


    // filtra
    public filtrarCompleto(filtro: Validacao, ordenar: string): Observable<Validacao[]> {

      const novaUrl =  this.montarFiltro(filtro);
      let urlModify = this.pagerComponent.formatarUrl(this.url + '/completo', novaUrl, 100, 0);
      if (ordenar) {
        urlModify += '&sort= ' + ordenar;
      } else {
        urlModify += '&sort=  corrigido asc';
      }

      return this.http.get(urlModify)
              .pipe(map(response => {
                  const result = response;
                  PagerComponent.allItems = result;
                  return <Validacao[]> response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }

    public filtrar(filtro: Validacao): Observable<Validacao[]> {
      const novaUrl =  this.montarFiltro(filtro);
      const urlModify = this.pagerComponent.formatarUrl(this.url, novaUrl, 100, 0);

      return this.http.get(urlModify)
              .pipe(map(response => {
                const result = response;
                  PagerComponent.allItems = result;
                  return <Validacao[]> response;
              }),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
    }

    private montarFiltro(filtro: Validacao): string {
      let colocaVirgula = false;
      let novaUrl = '{' ;
      if (filtro.codigoEstudoSocioEconomico) {
       novaUrl += 'codigoEstudoSocioEconomico:\"' + filtro.codigoEstudoSocioEconomico + '\"';
       colocaVirgula = true;
      }
      if (filtro.codigoPergunta ){
        if (colocaVirgula) {
          novaUrl += ', ';
        }
       novaUrl += 'codigoPergunta:\"' + filtro.codigoPergunta + '\"';
       colocaVirgula = true;
      }
      if (filtro.codigoGrupoFamiliar) {
        if (colocaVirgula) {
          novaUrl += ', ';
        }
       novaUrl += 'codigoGrupoFamiliar:\"' + filtro.codigoGrupoFamiliar + '\"';
       colocaVirgula = true;
      }
      novaUrl +=  '}';

      return novaUrl;
    }

    // recupera por id
    public getId(id: number): Observable<Validacao> {
        return this.http.get(this.url + '/' + id)
                  .pipe(map(this.extractObjectData),
                     catchError(this.handleError),
                     publishReplay(1),
                     refCount());
    }

    public alterarStatusAvaliacao(validacao: Validacao): Observable<Estudo> {
        const body = JSON.stringify(validacao);
        return this.http.put(this.url + '/alterarSituacao/' + validacao.codigoEstudoSocioEconomico , body)
          .pipe(map(response => <Estudo> response),
             catchError(this.handleError),
             publishReplay(1),
            refCount());
    }



    // extrai lista da resposta http
    private extractListData(res: any) {
      return res as Validacao[] ;
    }

    // extrai objeto da resposta http
    private extractObjectData(res: any) {
      return res as Validacao ;
    }

    removeNull(key, value) {
      // Filtering out properties
      if (value === null) {
        return undefined;
      }
      return value;
    }

}
